import Vue from 'vue'
import store from '../../store'

export default {
  createPrescription (file, action, channelId) {
    return Vue.http.post(window.API_URL + 'doctors/prescriptions/create', file, {
      progress (e) {
        if (e.lengthComputable && action === 'send') {
          file.progress = parseInt(e.loaded / e.total * 100)
          file.state = 'uploading'
          store.dispatch('message/documentUploadProgress', {file, channelId})
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/customer/prescription.js